"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnboardingHandlers = void 0;
const user_1 = require("@completeanatomy/user");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const router_1 = require("../router");
function useOnboardingHandlers() {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const user = (0, user_1.useUser)();
    /**
     * On component mount, start onboarding flow.
     * On any auth changes, repeat onboarding flow.
     */
    (0, react_1.useEffect)(() => {
        navigate(`${router_1.Route.Base}/${router_1.Route.SelectRegion}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user === null || user === void 0 ? void 0 : user.identifier]);
}
exports.useOnboardingHandlers = useOnboardingHandlers;
